export type TemplateConfigPatch = {
  configDefaults: Record<string, string>;
  unsetKeys: string[];
};

/** Build a partial config patch without resubmitting hidden sensitive values. */
export function buildTemplateConfigPatch(
  values: Record<string, string>,
  dirtyKeys: ReadonlySet<string>,
  unsetKeys: ReadonlySet<string>
): TemplateConfigPatch {
  const configDefaults: Record<string, string> = {};
  for (const key of dirtyKeys) {
    if (!unsetKeys.has(key)) configDefaults[key] = values[key] ?? '';
  }
  return { configDefaults, unsetKeys: [...unsetKeys].sort() };
}
